<div class="confirm-modal ig-modal resize-image-modal">
  <div class="close-button">
    <mat-icon (click)="close()">clear</mat-icon>
  </div>
  <h3 class="title">RESIZE IMAGE</h3>

  <div class="edit-wrap">
    <ig-image-cropper #cropper [class.invisible]="!isImgLoaded" [imageData]="imageData"
      [cropperSettings]="cropperSettings"></ig-image-cropper>

    <ig-spinner *ngIf="!isImgLoaded"></ig-spinner>
  </div>

  <!--  <mat-checkbox *ngIf="isImageChanged" [(ngModel)]="hasCopyrights"-->
  <!--    >Please note that any images uploaded or used in this software must either be royalty-free or owned by the client. By uploading or using an image, you acknowledge that you have the necessary rights to use it and that you will be solely responsible for any copyright infringement or other legal issues that may arise from the use of the image. We strongly advise our users to exercise due diligence and ensure that they have the necessary rights to use any images uploaded or used in this software.-->
  <!--  </mat-checkbox>-->

  <div class="action-btns">
    <ig-button class="btn-primary" #confirmButton color="primary" size="md" [isAsync]="true"
      (trigger)="confirm($event)">
      OK
    </ig-button>
    <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
      Cancel
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/resize.image.modal/resize.image.modal.component.html